import {connect} from '@modifi/redux'
import {selectLocale} from '@modifi/plugin-i18n'
import {aFetchCmsPage, selectCmsPage, selectCmsPageIsLoading} from './store'

import CmsPage, {RemotePageProps} from './CmsPage'

const mapStateToProps = (
  state: Record<string, any>
): Pick<RemotePageProps, 'pageContent' | 'isLoading' | 'locale'> => ({
  pageContent: selectCmsPage(state) ?? undefined,
  isLoading: selectCmsPageIsLoading(state),
  locale: selectLocale(state),
  // hasError: selectCmsPageHasError(state),
})

const mapDispatchToProps: Pick<RemotePageProps, 'fetch'> = {
  fetch: aFetchCmsPage,
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsPage)
